// 公共配置API 用于获取枚举值
import request from '@/utils/request'

// 根据传入的数据生成对应的枚举列表
export function enDataIn(api_name, type, params_name, content, condition_key = '') {
  return request({
    url: `/condition_config/derive`,
    method: 'post',
    data: {
      api_name,
      type,
      params_name,
      condition_key: condition_key,
      content
    }
  })
}

// 根据api名称获取参数枚举值
export function apiNameIn(params) {
  return request({
    url: `/condition_config/enumerations`,
    method: 'get',
    params
  })
}

// 根据api名称获取列表筛选条件
export function apiNameInFilter(params) {
  return request({
    url: `/condition_config/filterings`,
    method: 'get',
    params
  })
}
